import Anchor from 'components/Anchor'
import Typography from 'components/Typography'
import { FC, useMemo } from 'react'
import classNames from 'classnames'
import styles from './Breadcrumb.module.scss'

export type TProps = {
  variant?: 'scroll' | 'wrap'
  list: Array<{
    to: string
    label: string
    active?: boolean
    onClick?: (label: string, url: string) => void
  }>
}

const Breadcrumb: FC<TProps> = ({ variant = 'scroll', list }) => {
  const breadcrumbSchemaList = useMemo(
    () =>
      list.reduce<Array<Record<string, unknown>>>(
        // eslint-disable-next-line max-params
        (prev, { label, to }, index) => [
          ...prev,
          {
            '@type': 'ListItem',
            position: index,
            name: label,
            item: {
              '@type': 'WebPage',
              id: `https://emcasa.com${to}`,
            },
          },
        ],
        [],
      ),
    [list],
  )

  return (
    <>
      <script
        type="application/ld+json"
        data-testid="breadcrumbSchemaScript"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            name: 'BreadcrumbList',
            itemListElement: breadcrumbSchemaList,
          }),
        }}
      />
      <ol
        className={classNames(styles.ecBreadcrumbList, {
          [styles.ecBreadcrumbListScroll]: variant === 'scroll',
          [styles.ecBreadcrumbListWrap]: variant === 'wrap',
        })}
      >
        {list.map(({ to, onClick, label, active }, key) => (
          <li key={`label${key}`} className={styles.ecBreadcrumbListItem}>
            {!active ? (
              <Anchor
                href={to}
                onClick={() => {
                  if (onClick) onClick(label, to)
                }}
              >
                {label}
              </Anchor>
            ) : (
              <Typography as="p" variant="Paragraph" bold>
                {label}
              </Typography>
            )}
          </li>
        ))}
      </ol>
    </>
  )
}

export default Breadcrumb
